import React from "react";
import userManager from "../helpers/UserManager";

export default class LogoutCallback extends React.Component {
    async componentDidMount() {
        try {

            await userManager.signoutRedirectCallback();
        }
        catch (e) {
            console.warn("signoutRedirectCallback:", e);
        }

        await userManager.removeUser();
        localStorage.removeItem("UserIsLogged");

        const u = await userManager.getUser();
        console.log("after removeUser getUser =", u);

        window.location.replace("/login");
    }

    render() {
        return <div></div>;
    }
}
